import './WhatsNewModal.scss';

import { useEffect, useState } from 'react';

import { Badge } from 'components/Badge/Badge';
import { DefaultRoutes } from 'Routes';
import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import SectionTitle from 'components/TextComps/SectionTitle';
import accessOnDemandRecordingsImg from 'images/TrackmanEvents/accessOnDemandRecordings.png';
import exploreUpcomingEventsImg from 'images/TrackmanEvents/exploreUpcomingEvents.png';
import introducingEventsImg from 'images/TrackmanEvents/introducingEvents.png';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const WhatsNewModal = observer(() => {
  const [isModalOn, setIsModalOn] = useState(false);
  const [step, setStep] = useState(1);
  const totalSteps = 3;
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (!localStorage.isEventsModalDisplayed && location.pathname !== DefaultRoutes.LandingPage) {
      setIsModalOn(true);
      localStorage.isEventsModalDisplayed = 'true';
    }
  }, [location.pathname]);

  const stepsContent = [
    {
      stepTitle: t('IntroducingEvents', { ns: 'trackmanEvents' }),
      stepDescription: t('StayUpdatedOnTheLatestEvents', { ns: 'trackmanEvents' }),
      stepImage: introducingEventsImg,
    },
    {
      stepTitle: t('ExploreUpcomingEvents', { ns: 'trackmanEvents' }),
      stepDescription: t('SignUpForUpcomingEvents', { ns: 'trackmanEvents' }),
      stepImage: exploreUpcomingEventsImg,
    },
    {
      stepTitle: t('AccessOnDemandContent', { ns: 'trackmanEvents' }),
      stepDescription: t('BrowseOurOnDemandLibrary', { ns: 'trackmanEvents' }),
      stepImage: accessOnDemandRecordingsImg,
    },
  ];

  return (
    <Modal
      cancelBtn={{
        label: t('Skip', { ns: 'trackmanEvents' }),
        onClick: () => setIsModalOn(false),
      }}
      confirmBtn={{
        label: step < totalSteps ? t('Next', { ns: 'trackmanEvents' }) : t('Finish', { ns: 'trackmanEvents' }),
        onClick: () => (step === totalSteps ? setIsModalOn(false) : setStep(step + 1)),
      }}
      onClose={() => setIsModalOn(false)}
      title={t('StepCount', { step: step, totalSteps: totalSteps, ns: 'trackmanEvents' })}
      titleIcon={null}
      open={isModalOn}
      className='whats-new-modal'
    >
      <div className='modal-body'>
        <Badge badgeText={t('New', { ns: 'trackmanEvents' })} />
        {stepsContent.map((stepContent, index) => (
          <div key={index} className={`step-content ${step === index + 1 ? 'active' : ''}`}>
            <div className='image-wrapper'>
              <img src={stepContent.stepImage} alt={stepContent.stepTitle} />
            </div>
            <SectionTitle>
              <>{stepContent.stepTitle}</>
            </SectionTitle>
            <Paragraph>
              <>{stepContent.stepDescription}</>
            </Paragraph>
          </div>
        ))}
      </div>
    </Modal>
  );
});

export default WhatsNewModal;
